<iframe class="advocate-chat-iframe {{iframe_class}}"
  src="https://chat.thehotline.us/partners/everfi/index.html?skill={{skill}}&dkey={{deployKey}}" />
